/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

'use strict';

var log = require('../../../utils/logger')('splitio-settings');
var isLocalStorageAvailable = require('../../../utils/localstorage/isAvailable');

var _require = require('../../../utils/constants'),
    LOCALHOST_MODE = _require.LOCALHOST_MODE,
    STORAGE_MEMORY = _require.STORAGE_MEMORY,
    STORAGE_LOCALSTORAGE = _require.STORAGE_LOCALSTORAGE;

var ParseStorageSettings = function ParseStorageSettings(settings) {
  var mode = settings.mode,
      _settings$storage = settings.storage,
      _settings$storage$typ = _settings$storage.type,
      type = _settings$storage$typ === undefined ? STORAGE_MEMORY : _settings$storage$typ,
      _settings$storage$opt = _settings$storage.options,
      options = _settings$storage$opt === undefined ? {} : _settings$storage$opt,
      prefix = _settings$storage.prefix;


  if (prefix) {
    prefix += '.SPLITIO';
  } else {
    prefix = 'SPLITIO';
  }

  if (mode === LOCALHOST_MODE) return {
    type: STORAGE_MEMORY,
    prefix: prefix
  };

  // If an invalid storage type is provided OR we want to use LOCALSTORAGE and
  // it's not available, fallback into MEMORY
  if (type !== STORAGE_MEMORY && type !== STORAGE_LOCALSTORAGE || type === STORAGE_LOCALSTORAGE && !isLocalStorageAvailable()) {
    type = STORAGE_MEMORY;
    log.warn('Invalid or unavailable storage. Fallbacking into MEMORY storage');
  }

  return {
    type: type,
    options: options,
    prefix: prefix
  };
};

module.exports = ParseStorageSettings;


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/utils/settings/storage/browser.js
// module id = 738
// module chunks = 10